// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1z4xv","label":"styles_label__1cf0r"};